import { ManagedContentBanner } from '@seek/cms-ui';
import React, { type ComponentProps } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { Environment } from 'src/app/config/environments';
import { isProd, isServerRendering } from 'src/app/utils/environment';
import { log } from 'src/app/utils/logging';
import { useConfig } from 'src/app/views/hooks/useConfig';

type SystemBannerContext = 'job_posting_global' | 'job_posting_pay_and_post';

export const SystemBanner = ({
  context,
  style,
}: {
  context: SystemBannerContext;
  style?: ComponentProps<typeof ManagedContentBanner>['style'];
}) => {
  const environment = isProd() ? Environment.PROD : Environment.STAGING;
  const locale = useConfig().getLocale();
  const platform = 'employer';

  return (
    <ErrorBoundary
      fallbackRender={() => null}
      onError={(error) => {
        log.error('SystemBanner | Failed to render', {
          error,
          context,
          locale,
        });
      }}
    >
      {!isServerRendering() ? (
        <ManagedContentBanner
          locale={locale}
          platform={platform}
          environment={environment}
          context={context}
          style={style}
        />
      ) : null}
    </ErrorBoundary>
  );
};
